<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.roles')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.role.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.role.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="roles"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="role-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="name" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
          </tr>
          <tr class="filter">
            <th>
              <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
          <ng-container *ngIf="role.editable === true">
            <tr (click)="onOpen(role)" (keyup.enter)="onOpen(role)" hoverOnRight="admin.role.show" tabindex="0">
              <td><span role="link" [attr.aria-label]="role.name">{{ role.translated_title }}</span></td>
            </tr>
          </ng-container>
          <ng-container *ngIf="role.editable !== true">
            <tr tabindex="0">
              <td>{{ role.translated_title }} <span class="restrained">({{ t('common.labels.not_editable') }})</span></td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="2">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
